import React, { useCallback } from 'react';
import InsuranceDocument from './InsuranceDocument';
import PropTypes from 'prop-types';
import { useNavigationStepData } from 'hooks';
import steps from 'constants/initialSteps';

const InsuranceDocumentContainer = ({ data }) => {
  const { setNavigationStep } = useNavigationStepData();

  const onEdit = useCallback(
    item => {
      setNavigationStep(item.documentId, item.navigationStep);
      const step = steps.find(x => x.code === item.navigationStep);
      const route = step.route.replace('{id}', item.documentId);
      return {
        pathname: route
      };
    },
    [setNavigationStep]
  );

  return <InsuranceDocument data={data} onEdit={onEdit} />;
};

InsuranceDocumentContainer.propTypes = {
  data: PropTypes.object.isRequired
};
export default InsuranceDocumentContainer;
